import { render, staticRenderFns } from "./activityPropDetails.vue?vue&type=template&id=54c0e2cc&scoped=true&"
import script from "./activityPropDetails.vue?vue&type=script&lang=js&"
export * from "./activityPropDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c0e2cc",
  null
  
)

export default component.exports